// extracted by mini-css-extract-plugin
var _1 = "t2Ld";
var _2 = "t2Le";
export { _1 as "footer", _2 as "scrolled" }
